import React from "react";
import DataSets from "./DataSets";

const Landing = () => {
  return <>
    <DataSets />
  </>
}

export default Landing;
